/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioStatus } from './PortfolioStatus';
import {
    PortfolioStatusFromJSON,
    PortfolioStatusFromJSONTyped,
    PortfolioStatusToJSON,
    PortfolioStatusToJSONTyped,
} from './PortfolioStatus';
import type { PortfolioAdditionalClassification } from './PortfolioAdditionalClassification';
import {
    PortfolioAdditionalClassificationFromJSON,
    PortfolioAdditionalClassificationFromJSONTyped,
    PortfolioAdditionalClassificationToJSON,
    PortfolioAdditionalClassificationToJSONTyped,
} from './PortfolioAdditionalClassification';
import type { PortfolioType } from './PortfolioType';
import {
    PortfolioTypeFromJSON,
    PortfolioTypeFromJSONTyped,
    PortfolioTypeToJSON,
    PortfolioTypeToJSONTyped,
} from './PortfolioType';
import type { PortfolioCashAccountCreateRequest } from './PortfolioCashAccountCreateRequest';
import {
    PortfolioCashAccountCreateRequestFromJSON,
    PortfolioCashAccountCreateRequestFromJSONTyped,
    PortfolioCashAccountCreateRequestToJSON,
    PortfolioCashAccountCreateRequestToJSONTyped,
} from './PortfolioCashAccountCreateRequest';
import type { PortfolioLinkType } from './PortfolioLinkType';
import {
    PortfolioLinkTypeFromJSON,
    PortfolioLinkTypeFromJSONTyped,
    PortfolioLinkTypeToJSON,
    PortfolioLinkTypeToJSONTyped,
} from './PortfolioLinkType';
import type { PortfolioExternalAccountType } from './PortfolioExternalAccountType';
import {
    PortfolioExternalAccountTypeFromJSON,
    PortfolioExternalAccountTypeFromJSONTyped,
    PortfolioExternalAccountTypeToJSON,
    PortfolioExternalAccountTypeToJSONTyped,
} from './PortfolioExternalAccountType';
import type { PortfolioServicingRole } from './PortfolioServicingRole';
import {
    PortfolioServicingRoleFromJSON,
    PortfolioServicingRoleFromJSONTyped,
    PortfolioServicingRoleToJSON,
    PortfolioServicingRoleToJSONTyped,
} from './PortfolioServicingRole';

/**
 * 
 * @export
 * @interface PortfolioCreateRequest
 */
export interface PortfolioCreateRequest {
    /**
     * PCO portfolio number in dotted form {type}.{seq} (e.g. 02.02).
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    portfolioNumber: string;
    /**
     * Unformatted sequence number of the portfolio within the business relationship (e.g. 1 for portfolio number 02.01).
     * @type {number}
     * @memberof PortfolioCreateRequest
     */
    sequenceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    rubrik?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    details?: string;
    /**
     * 
     * @type {PortfolioType}
     * @memberof PortfolioCreateRequest
     */
    portfolioType: PortfolioType;
    /**
     * 
     * @type {PortfolioStatus}
     * @memberof PortfolioCreateRequest
     */
    portfolioStatus?: PortfolioStatus;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    referenceCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    chargingCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    allocatedBo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioCreateRequest
     */
    specialBoEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    businessRelationshipId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    serviceAgreementId?: string;
    /**
     * 
     * @type {Date}
     * @memberof PortfolioCreateRequest
     */
    closedAt?: Date;
    /**
     * 
     * @type {Array<PortfolioCashAccountCreateRequest>}
     * @memberof PortfolioCreateRequest
     */
    cashAccounts: Array<PortfolioCashAccountCreateRequest>;
    /**
     * 
     * @type {PortfolioServicingRole}
     * @memberof PortfolioCreateRequest
     */
    servicingRole?: PortfolioServicingRole;
    /**
     * External account number. Must be sent together with externalAccountType.
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    externalAccountNumber?: string;
    /**
     * 
     * @type {PortfolioExternalAccountType}
     * @memberof PortfolioCreateRequest
     */
    externalAccountType?: PortfolioExternalAccountType;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    remarks?: string;
    /**
     * 
     * @type {PortfolioAdditionalClassification}
     * @memberof PortfolioCreateRequest
     */
    additionalClassification?: PortfolioAdditionalClassification;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCreateRequest
     */
    linkedPortfolioId?: string;
    /**
     * 
     * @type {PortfolioLinkType}
     * @memberof PortfolioCreateRequest
     */
    linkType?: PortfolioLinkType;
}



/**
 * Check if a given object implements the PortfolioCreateRequest interface.
 */
export function instanceOfPortfolioCreateRequest(value: object): value is PortfolioCreateRequest {
    if (!('portfolioNumber' in value) || value['portfolioNumber'] === undefined) return false;
    if (!('portfolioType' in value) || value['portfolioType'] === undefined) return false;
    if (!('chargingCurrency' in value) || value['chargingCurrency'] === undefined) return false;
    if (!('cashAccounts' in value) || value['cashAccounts'] === undefined) return false;
    return true;
}

export function PortfolioCreateRequestFromJSON(json: any): PortfolioCreateRequest {
    return PortfolioCreateRequestFromJSONTyped(json, false);
}

export function PortfolioCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'portfolioNumber': json['portfolioNumber'],
        'sequenceNumber': json['sequenceNumber'] == null ? undefined : json['sequenceNumber'],
        'rubrik': json['rubrik'] == null ? undefined : json['rubrik'],
        'details': json['details'] == null ? undefined : json['details'],
        'portfolioType': PortfolioTypeFromJSON(json['portfolioType']),
        'portfolioStatus': json['portfolioStatus'] == null ? undefined : PortfolioStatusFromJSON(json['portfolioStatus']),
        'referenceCurrency': json['referenceCurrency'] == null ? undefined : json['referenceCurrency'],
        'chargingCurrency': json['chargingCurrency'],
        'allocatedBo': json['allocatedBo'] == null ? undefined : json['allocatedBo'],
        'specialBoEnabled': json['specialBoEnabled'] == null ? undefined : json['specialBoEnabled'],
        'businessRelationshipId': json['businessRelationshipId'] == null ? undefined : json['businessRelationshipId'],
        'serviceAgreementId': json['serviceAgreementId'] == null ? undefined : json['serviceAgreementId'],
        'closedAt': json['closedAt'] == null ? undefined : (new Date(json['closedAt'])),
        'cashAccounts': ((json['cashAccounts'] as Array<any>).map(PortfolioCashAccountCreateRequestFromJSON)),
        'servicingRole': json['servicingRole'] == null ? undefined : PortfolioServicingRoleFromJSON(json['servicingRole']),
        'externalAccountNumber': json['externalAccountNumber'] == null ? undefined : json['externalAccountNumber'],
        'externalAccountType': json['externalAccountType'] == null ? undefined : PortfolioExternalAccountTypeFromJSON(json['externalAccountType']),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'additionalClassification': json['additionalClassification'] == null ? undefined : PortfolioAdditionalClassificationFromJSON(json['additionalClassification']),
        'linkedPortfolioId': json['linkedPortfolioId'] == null ? undefined : json['linkedPortfolioId'],
        'linkType': json['linkType'] == null ? undefined : PortfolioLinkTypeFromJSON(json['linkType']),
    };
}

export function PortfolioCreateRequestToJSON(json: any): PortfolioCreateRequest {
    return PortfolioCreateRequestToJSONTyped(json, false);
}

export function PortfolioCreateRequestToJSONTyped(value?: PortfolioCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portfolioNumber': value['portfolioNumber'],
        'sequenceNumber': value['sequenceNumber'],
        'rubrik': value['rubrik'],
        'details': value['details'],
        'portfolioType': PortfolioTypeToJSON(value['portfolioType']),
        'portfolioStatus': PortfolioStatusToJSON(value['portfolioStatus']),
        'referenceCurrency': value['referenceCurrency'],
        'chargingCurrency': value['chargingCurrency'],
        'allocatedBo': value['allocatedBo'],
        'specialBoEnabled': value['specialBoEnabled'],
        'businessRelationshipId': value['businessRelationshipId'],
        'serviceAgreementId': value['serviceAgreementId'],
        'closedAt': value['closedAt'] == null ? value['closedAt'] : value['closedAt'].toISOString().substring(0,10),
        'cashAccounts': ((value['cashAccounts'] as Array<any>).map(PortfolioCashAccountCreateRequestToJSON)),
        'servicingRole': PortfolioServicingRoleToJSON(value['servicingRole']),
        'externalAccountNumber': value['externalAccountNumber'],
        'externalAccountType': PortfolioExternalAccountTypeToJSON(value['externalAccountType']),
        'remarks': value['remarks'],
        'additionalClassification': PortfolioAdditionalClassificationToJSON(value['additionalClassification']),
        'linkedPortfolioId': value['linkedPortfolioId'],
        'linkType': PortfolioLinkTypeToJSON(value['linkType']),
    };
}

